import API from '@/api'
import storage from '@/helpers/storage'

export default {
  namespaced: true,
  state: {
    userLoggedIn: null, // ex value: { id, nama_panjang, role_id, ... }
    targetTime: '',
    countdown: '',
    interval: null,
  },
  mutations: {
    UPDATE_USER_LOGGED_IN(state, val) {
      state.userLoggedIn = val
    },
    setTargetTime(state, targetTime) {
      state.targetTime = targetTime;
    },
    setCountdown(state, countdown) {
      state.countdown = countdown;
    },
    clearInterval(state) {
      if (state.interval) {
        clearInterval(state.interval);
      }
    },
  },
  actions: {
    startCountdown({ state, commit, dispatch }) {
      if (state.interval) {
        clearInterval(state.interval);
      }

      state.interval = setInterval(() => {
        const now = new Date().getTime();
        const distance = state.targetTime - now;

        if (distance <= 0) {
          alert('Waktu anda sudah habis! Anda akan diarahkan ke halaman login.');
          dispatch('logout')
            .then(() => {
              window.location.href = '/login/tps'
            })
            .catch((err) => {
              console.error('Terjadi kesalahan saat logout', err);
            });
          commit('clearInterval');
        } else {
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          commit('setCountdown', `${hours}h ${minutes}m ${seconds}s`);
        }
      }, 1000);
    },
    checkToken({ commit }) {
      return new Promise(res => {
        (async () => {
          try {
            const { data } = await API.auth.checkToken()
            commit('UPDATE_USER_LOGGED_IN', data)
            return res(true)
          } catch (error) {
            commit('UPDATE_USER_LOGGED_IN', null)
            storage.clearStorage()
            return res()
          }
        })()
      })
    },
    logout({ commit }) {
      return new Promise(res => {
        (async () => {
          await API.auth.logout()
          commit('UPDATE_USER_LOGGED_IN', null)
          storage.clearStorage()
          return res()
        })()
      })
    },
  },
  getters: {
    isAuthenticated: state => !!state.userLoggedIn,
  },
}
